import { MainLayout } from '@app/components';
import { RoutingMap } from '@app/entities';
import { useInitApp } from '@app/hooks';
import useGetThemeClass from '@app/hooks/useGetThemeClass';
import { getLocationSubdomain } from '@common/utils';
import { MPFallback, MPResult } from '@components';
import AboutUs from '@pages/AboutUs';
import Analytics from '@pages/Analytics/index';
import AppDetails from '@pages/AppDetails';
import { EditApp } from '@pages/AppDetails/sections';
import AppPage from '@pages/AppPage';
import Authentication from '@pages/Authentication';
import LegalClaimer from '@pages/Authentication/views/LegalClaimer';
import Cli from '@pages/Cli';
import MainDashBoard from '@pages/MainDashBoard';
import NewProject from '@pages/NewProject';
import Settings from '@pages/Settings';
import AccountSettings from '@pages/Settings/Account';
import ApiTokensSettings from '@pages/Settings/ApiTokens';
import OrganizationSettings from '@pages/Settings/Organization';
import CreateOrganization from '@pages/Settings/Organization/Create/CreateOrganization';
import OrganizationDetails from '@pages/Settings/Organization/Create/OrganizationDetails';
import ProfileSettings from '@pages/Settings/Profile';
import { Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

export default function Router() {
    const { scrollClass } = useGetThemeClass();
    useInitApp();

    return (
        <>
            <div className={scrollClass}>
                <Suspense fallback={<MPFallback />}>
                    <RouterProvider router={router} />
                </Suspense>
            </div>

            <ToastContainer />
        </>
    );
}
const subdomain = getLocationSubdomain();
const router = createBrowserRouter([
    {
        path: RoutingMap.Home,
        element: <MainLayout />,
        children: subdomain
            ? [
                  {
                      path: '/',
                      element: <AppPage />,
                  },
              ]
            : [
                  {
                      path: '/',
                      element: <MainDashBoard />,
                  },
                  {
                      path: '/a/:name',
                      element: <AppDetails />,
                  },
                  {
                      path: '/a/:name/edit',
                      element: <EditApp />,
                  },
                  {
                      path: '/a/:name/app',
                      element: <AppPage />,
                  },
                  {
                      path: RoutingMap.NewProject,
                      element: <NewProject />,
                  },
                  {
                      path: RoutingMap.AppPage,
                      element: <AppPage />,
                  },
                  {
                      path: RoutingMap.Cli,
                      element: <Cli />,
                  },
                  {
                      path: RoutingMap.Analytcis,
                      element: <Analytics />,
                  },
                  {
                      path: RoutingMap.About,
                      element: <AboutUs />,
                  },
                  {
                      path: RoutingMap.LegalClaimer,
                      element: <LegalClaimer />,
                  },
                  {
                      path: RoutingMap.Settings.Root,
                      element: <Settings />,
                      children: [
                          {
                              path: RoutingMap.Settings.Profile,
                              element: <ProfileSettings />,
                          },
                          {
                              path: RoutingMap.Settings.Account,
                              element: <AccountSettings />,
                          },
                          {
                              path: RoutingMap.Settings.ApiTokens,
                              element: <ApiTokensSettings />,
                          },
                          {
                              path: RoutingMap.Settings.Organizations,
                              element: <OrganizationSettings />,
                          },
                          {
                              path: RoutingMap.Settings.NewOrganization,
                              element: <CreateOrganization />,
                          },
                          {
                              path: RoutingMap.Settings.OrganitionDetails,
                              element: <OrganizationDetails />,
                          },
                      ],
                  },
              ],
    },
    {
        path: RoutingMap.Auth,
        element: <Authentication />,
        children: [
            {
                path: RoutingMap.Login,
                element: <Authentication />,
            },
            {
                path: RoutingMap.Signup,
                element: <Authentication />,
            },
        ],
    },
    {
        path: '*',
        element: <MPResult status={404} />,
    },
]);
